import { useRef } from "react";
import { Link } from "react-router-dom";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { SplitHeadline, Reveal } from "./Motion";
import { CtaPair, Stripes } from "./Bits";

export const PageHero = ({ eyebrow, crumbs = [], lines, intro, image, alt, cta = true, children, testId = "page-hero" }) => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", reduce ? "0%" : "16%"]);
  return (
    <section ref={ref} className="relative overflow-hidden bg-navy grain" data-testid={testId}>
      <div className="grid-lines absolute inset-0" aria-hidden="true" />
      <div className="container-x relative grid gap-12 py-16 sm:py-24 lg:grid-cols-12 lg:items-center lg:py-28">
        <div className={image ? "lg:col-span-7" : "lg:col-span-10"}>
          <Reveal y={10} className="flex flex-wrap items-center gap-3">
            <Stripes className="h-3 w-9" animate />
            {crumbs.map((c) => (
              <span key={c.to} className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.2em] text-slate-300">
                <Link to={c.to} className="hover:text-flame">{c.label}</Link><span className="text-slate-500">/</span>
              </span>
            ))}
            <span className="eyebrow text-flame">{eyebrow}</span>
          </Reveal>
          <SplitHeadline lines={lines} accentLast className="mt-7 text-[2.6rem] font-extrabold leading-[0.95] tracking-tight text-white sm:text-6xl lg:text-7xl" testId="page-hero-title" />
          {intro && <Reveal delay={0.35}><p className="mt-7 max-w-2xl text-base leading-relaxed text-slate-300 md:text-lg">{intro}</p></Reveal>}
          {children}
          {cta && <Reveal delay={0.45} className="mt-9"><CtaPair testPrefix="page-hero" /></Reveal>}
        </div>
        {image && (
          <div className="relative lg:col-span-5">
            <motion.div initial={reduce ? false : { clipPath: "inset(100% 0 0 0)" }} animate={{ clipPath: "inset(0% 0 0 0)" }}
              transition={{ duration: 1.2, delay: 0.25, ease: [0.22, 1, 0.36, 1] }} className="relative aspect-[4/3] overflow-hidden rounded-md lg:aspect-[4/5]">
              <motion.img style={{ y }} src={image} alt={alt} className="absolute inset-0 h-[118%] w-full -translate-y-[8%] object-cover" />
            </motion.div>
            <Stripes className="absolute -bottom-3 left-6 h-6 w-24" />
          </div>
        )}
      </div>
    </section>
  );
};
